<template>
    <div class="preview_wrap">
        <el-tabs v-model="tabCurrent" @tab-click="handleTabClick">
            <el-tab-pane label="待审核" name="stay_audit">
                <StayAudit v-if="tabCurrent === 'stay_audit'" @callback="handleCallback"></StayAudit>
            </el-tab-pane>
            <el-tab-pane label="审核通过" name="pass_audit">
                <PassAudit v-if="tabCurrent === 'pass_audit'" @callback="handleCallback"></PassAudit>
            </el-tab-pane>
            <el-tab-pane label="审核拒绝" name="reject_audit">
                <RejectAudit v-if="tabCurrent === 'reject_audit'" @callback="handleCallback"></RejectAudit>
            </el-tab-pane>
            <el-tab-pane label="审核报告" name="report">
                <Report v-if="tabCurrent === 'report'" @callback="handleCallback"></Report>
            </el-tab-pane>
        </el-tabs>
        
        <!-- scroll top -->
        <div class="btn_scroll_top" v-if="scrollTopVisible" @click="handleScrollTop">
            <svg t="1713440979235" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4251" width="40" height="40">
                <path d="M792.748 599.403l-257.312-259.001c-5.7-5.73-13.683-8.998-23.437-8.998s-16.541 3.881-21.63 8.971l-261.758 260.585c-11.205 11.174-11.231 29.313-0.031 40.513 13.731 13.731 34.927 5.614 40.544 0.056l214.226-213.168v372.648c0 15.844 12.835 28.653 28.649 28.653 15.817 0 28.653-12.813 28.653-28.653v-374.053l211.469 212.845c5.587 5.617 12.981 8.453 20.311 8.453 7.337 0 14.615-2.784 20.202-8.338 11.257-11.148 11.288-29.313 0.113-40.514v0 0zM827.161 251.635h-630.316c-15.817 0-28.653-12.835-28.653-28.645 0-15.818 12.835-28.653 28.653-28.653h630.316c15.84 0 28.645 12.835 28.645 28.653 0 15.81-12.805 28.645-28.645 28.645v0 0zM827.161 251.635z" fill="#409EFF" p-id="4252"></path>
            </svg>
        </div>
    </div>
</template>

<script>
import StayAudit from './StayAudit';
import PassAudit from './PassAudit';
import RejectAudit from './RejectAudit';
import Report from './Report';

export default {
    name: 'preview',
    
    data () {
        return {
            mainBox: '',
            tabCurrent: 'stay_audit',
            tabCom: '',
            scrollTopVisible: false
        }
    },
    
    components: {
        StayAudit,
        PassAudit,
        RejectAudit,
        Report
    },
    
    methods: {
        init() {
            this.mainBox = document.querySelector('.main-box');
            
            this.mainBox.addEventListener('scroll', (e) => {
                let _scrollTop = e.target.scrollTop || e.srcElement.scrollTop;
                this.scrollTopVisible = _scrollTop > 0;
            });
        },
        
        handleTabClick(tab, event) {
            console.log(tab, event);
            this.$nextTick(() => {
                this.handleScrollTop();
            });
        },
    
        handleCallback(data) {
            if (data && data.scrollTop) {
                this.handleScrollTop();
            }
        },
    
        handleScrollTop() {
            this.mainBox.scrollTop = 0;
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss">
.layout-box .content-box .main-box{
    overflow-x: hidden;
    overflow-y: auto;
}
.preview_wrap{
    position: relative;
    padding: 0 30px 10px 30px;
    & .el-tabs__header{
        position: sticky;
        top: 0;
        z-index: 2;
        background: #fff;
    }
    & .el-tabs__content{
        overflow: visible;
    }
    & .btn_scroll_top{
        position: fixed;
        right: 50px;
        bottom: 100px;
        width: 40px;
        height: 40px;
        cursor: pointer;
    }
}
</style>
